module.exports = __webpack_public_path__ + "static/media/linkedin.4126b9f7.jpg";